export default __webpack_public_path__ + "static/media/aboutMe.f90da7ac.jpg";